import React from 'react'
import styled from 'styled-components'
import Colors from '../../assets/styles/Colors'
import Responsive from '../../assets/config/Responsive'
//
//
const HorizontalCard: React.FC<{
  selected: boolean
  onClick?: () => void
  title?: string
  description?: string
  imgUrl?: string
  imgAlt?: string
  disabled?: boolean
  saleText?: string | number
  children?: any
  imgCHildren?: any
  className?: string
  imageStyle?: React.CSSProperties
  contentStyle?: React.CSSProperties
}> = ({
  selected = false,
  onClick,
  title,
  description,
  imgUrl,
  imgAlt,
  disabled = false,
  saleText,
  children,
  imgCHildren,
  className,
  imageStyle,
  contentStyle,
}) => {
  //
  //
  return (
    <Wrapper
      $sale={saleText ? true : false}
      $selected={selected}
      $disabled={disabled}
      onClick={onClick}
      className={className}
    >
      {saleText && <Sale>{saleText}</Sale>}
      <CircleStatus $selected={selected} />
      <Content style={contentStyle} className="horizontal-card-content">
        <ImgDiv className="image-div">
          {imgUrl && <Img style={imageStyle} src={imgUrl} alt={imgAlt || 'horizontal-card-alt'} />}
          {imgCHildren}
        </ImgDiv>
        <TextBlock>
          <Title>{title}</Title>
          {description ? <Description>{description}</Description> : null}
        </TextBlock>
      </Content>

      {children && <ChildrenElement className="horizontal-card-children">{children}</ChildrenElement>}
    </Wrapper>
  )
}
//
const ImgDiv = styled.div`
  /*  */
`
const ChildrenElement = styled.div``
const Sale = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${Colors.lightRed};
  font-size: 14px;
  color: ${Colors.primaryRed};
  padding: 9px 20px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;

  ${Responsive.mobile} {
    padding: 8px 18px;
  }
`
const Description = styled.p`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 0px;
  margin-right: 45px;

  ${Responsive.mobile} {
    margin-right: 0px;
  }
`
const Title = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 7px;

  ${Responsive.mobile} {
    margin-bottom: 5px;
  }
`
const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 30px;
  width: 100%;

  ${Responsive.mobile} {
    align-items: center;
    text-align: center;
    padding-left: 0px;
    margin-top: 18px;
  }
`
const Img = styled.img`
  height: 72px;
  margin-top: 5px;
  ${Responsive.mobile} {
    margin-top: 0;
    height: 64px;
  }
`
const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  ${Responsive.mobile} {
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
`
const Wrapper = styled.div<{ $selected: boolean; $disabled: boolean; $sale: boolean }>`
  max-width: 464px;
  width: 100%;
  user-select: none;

  /* disable */
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'unset')};
  opacity: ${({ $disabled }) => ($disabled ? '0.8' : 'unset')};
  /* disable */

  position: relative;
  outline: ${({ $selected }) => ($selected ? `solid 1px ${Colors.primaryBlack}` : 'unset')};
  box-shadow: ${({ $selected }) => ($selected ? 'unset' : `0 4px 50px 0 ${Colors.shadow}`)};
  background-color: ${Colors.white};
  border-radius: 8px;
  cursor: pointer;
  padding: 30px 32px;
  padding: ${({ $sale }) => ($sale ? '50px 32px' : `30px 32px`)};

  ${Responsive.mobile} {
    padding: 24px;
  }
`
const CircleStatus = styled.div<{ $selected: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  position: absolute;
  top: 15px;
  right: 15px;
  border: ${({ $selected }) => ($selected ? 'unset' : `solid 1px ${Colors.nevadaGrey}`)};
  box-shadow: ${({ $selected }) => ($selected ? `inset 0px 0px 0px 11px ${Colors.primaryRed}` : 'unset')};

  /*  */
  ${Responsive.mobile} {
    width: 26px;
    height: 26px;
    box-shadow: ${({ $selected }) => ($selected ? `inset 0px 0px 0px 9px ${Colors.primaryRed}` : 'unset')};
  }
`
//
export default HorizontalCard
